import type { AddressLocation, LocationPosition, RestrictToAreaOptions } from "./AddressAutocomplete.types";
interface IAddressComponent {
    short_name: string;
    types: Array<string>;
}

export const getCountryCodeFromAddressComponents = (addressComponents: Array<IAddressComponent>) => {
    const countryInfo = addressComponents.find((ac) => ac.types[0] === "country");
    if (!countryInfo?.short_name) {
        return "";
    }

    return countryInfo.short_name.toLowerCase();
};

export const parsePlaceResultResponse = (
    description: string,
    placeDetails: google.maps.places.PlaceResult,
): AddressLocation => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { address_components, geometry } = placeDetails || {};
    return {
        name: description,
        countryIsoCode: address_components ? getCountryCodeFromAddressComponents(address_components) : "",
        position:
            geometry && geometry.location
                ? {
                      latitude: geometry.location.lat(),
                      longitude: geometry.location.lng(),
                  }
                : undefined,
    };
};

// Note: requires google maps API with geometry library to be loaded
export function transformCenterWithRadiusToLatLngBounds(
    center: google.maps.LatLng,
    radiusMeters: number,
): google.maps.LatLngBounds {
    const northEast = google.maps.geometry.spherical.computeOffset(
        google.maps.geometry.spherical.computeOffset(center, radiusMeters, 90),
        radiusMeters,
        0,
    );
    const southWest = google.maps.geometry.spherical.computeOffset(
        google.maps.geometry.spherical.computeOffset(center, radiusMeters, -90),
        radiusMeters,
        -180,
    );

    return new google.maps.LatLngBounds(southWest, northEast);
}

export const isPlaceWithinRadius = (
    place: google.maps.places.AutocompletePrediction,
    restrictToArea?: RestrictToAreaOptions,
) => {
    if (!place.distance_meters) {
        return true;
    }
    return restrictToArea ? (place.distance_meters as number) <= restrictToArea?.radiusInMeters : true;
};

export const getLatLngLiteralFromLocationPosition = (position: LocationPosition): google.maps.LatLngLiteral => {
    return { lat: position.latitude, lng: position.longitude };
};

export const getLatLngLiteralFromAddressLocation = (
    location: AddressLocation,
): google.maps.LatLngLiteral | undefined => {
    if (!location.position) {
        return undefined;
    }

    return { lat: location.position.latitude, lng: location.position.longitude };
};

export const getLocationPositionFromLatLngLiteral = (latLngLiteral: google.maps.LatLngLiteral): LocationPosition => {
    return { latitude: latLngLiteral.lat, longitude: latLngLiteral.lng };
};
